import React, { CSSProperties, MouseEventHandler } from "react";
import { BsuObjectId, CMRItem } from "data/newObject";
import "./addEditObjectComponent.scss";
import { Button } from "@mui/material";
import { CurrentDrawerOpenType, toggleDrawer } from "state/slices/RightDrawerSlice";
import { useTypedDispatch } from "hooks/store";
import { Inventory } from "Classes/InventoryService";
import { builder } from "Classes/global";
import { dropPayload, onStartDrag } from "Classes/Interactions";

interface Item {
    item: CMRItem;
    itemId: string;
    device: string;
}

const style: CSSProperties = {
    cursor: "move",
};

const AddEditObjectItemComponent = ({ item, device }: Item): JSX.Element => {
    const dispatch = useTypedDispatch();

    const isAvailable = (): boolean => {
        if (typeof builder === "undefined") {
            return true;
        }

        const room = builder.room;
        switch (item.id) {
            case BsuObjectId.Stack:
                const maxStack = Inventory.MaxStack;
                const loadedStack = room.numberOfObjects.stack;
                if (maxStack <= loadedStack) {
                    return false;
                }
                break;

            case BsuObjectId.Trolley:
                const maxTrolley = Inventory.MaxTrolley;
                const loadedTrolley = room.numberOfObjects.trolley;
                if (maxTrolley <= loadedTrolley) {
                    return false;
                }
                break;

            case BsuObjectId.Anesthesia:
                const maxAnesthesia = Inventory.MaxAnesthesia;
                const loadedAnesthesia = room.numberOfObjects.anesthesia;
                if (maxAnesthesia <= loadedAnesthesia) {
                    return false;
                }
                break;

            case BsuObjectId.Surgeon:
                const maxSurgeon = Inventory.MaxSurgeon;
                const loadedSurgeon = room.numberOfObjects.surgeon;
                if (maxSurgeon <= loadedSurgeon) {
                    return false;
                }
                break;

            case BsuObjectId.Slave:
                const maxSlave = Inventory.MaxSlave;
                const loadedSlave = room.numberOfObjects.slave;
                if (maxSlave <= loadedSlave) {
                    return false;
                }
                break;

            case BsuObjectId.IBsu:
                const maxBsu = Inventory.MaxBSU;
                const totalBsu = room.numberOfObjects.bsu;

                if (maxBsu <= totalBsu) {
                    return false;
                }
                break;

            case BsuObjectId.VBsu:
                if (room.isVBSU) {
                    return false;
                }
                break;
            case BsuObjectId.Console:
                const maxConsole = Inventory.MaxConsole;
                const loadedConsole = room.numberOfObjects.console;
                if (maxConsole <= loadedConsole) {
                    return false;
                }
                break;

            case BsuObjectId.Trocar:
                const maxTrocar = Inventory.MaxTrocar;
                const loadedTrocar = room.numberOfObjects.trocar;
                if (maxTrocar <= loadedTrocar) {
                    return false;
                }
                break;
        }
        return true;
    };

    const placeItem: MouseEventHandler<HTMLDivElement> = () => {
        dispatch(toggleDrawer(CurrentDrawerOpenType.AddObject));
        const payload = onStartDrag(item.id);
        dropPayload(payload);
    };

    return (
        <>
            <div
                className={`item ${isAvailable() ? "" : "disabled"}`}
                id={item.id === "trocar" ? "trocar" : ""}
                style={style}
                onClick={placeItem}
            >
                <Button className="itemWrapper">
                    <picture>
                        <source srcSet={item.url} media="(min-width: 800px)" />
                        <img
                            src={item.url}
                            alt={item.name}
                            id={item.id === "trocar" ? "trocar" : ""}
                            className={item.id === "stack" ? "stack" : ""}
                        />
                    </picture>
                    {device === "desktop" && <span className="buttonOverlay">{item.name}</span>}
                </Button>
                {<div className="label mobile">{item.name}</div>}
            </div>
        </>
    );
};

export default AddEditObjectItemComponent;
